<template>
    <b-list-group flush>
        <b-list-group-item>
            <span id="info-gradient" class="icon-button ml-1 mr-1 float-right">                    <font-awesome-icon
                    icon="info-circle"/>                </span>
            <b-tooltip target="info-gradient"><em>Global</em> sets the color map to the range of values of all combined columns while <em>per-axis</em> sets it separably for each column.
            </b-tooltip>
            <two-state-button :disabled="notLoaded" name="Gradient scope" state-on="per-axis" state-off="global"
                              @input="onSettingChange('gradientScope')"></two-state-button>
            <span id="info-nodeview" class="icon-button ml-1 mr-1 float-right">
                    <font-awesome-icon icon="info-circle"/>
                </span>
            <b-tooltip target="info-nodeview">Changes the small visualization inside nodes that summarizes the values. <em>Line</em> displays a distortion line, <em>histogram</em> displays a frequency plot.
            </b-tooltip>
            <two-state-button :disabled="notLoaded" name="Inner node view" state-on="histogram" state-off="line"
                              @input="onSettingChange('nodeView')"></two-state-button>
            <span id="info-nodeheight" class="icon-button ml-1 mr-1 float-right">
                    <font-awesome-icon icon="info-circle"/>
                </span>
            <b-tooltip target="info-nodeheight"><em>Interval</em> maps each ndoe height to the length of the interval of value it represents while <em>weight</em> maps it to the number of rows it represents.
            </b-tooltip>
            <two-state-button :disabled="notLoaded" name="Node height" state-on="interval" state-off="weight"
                              @input="onSettingChange('verticalMapping')"></two-state-button>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
    import {mapGetters} from "vuex";
    import TwoStateButton from "./TwoStateButton";
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

    export default {
        name: "SettingPanel",
        components: {TwoStateButton, FontAwesomeIcon},
        data() {
            return {
                gradientScope: true,
                nodeView: true,
                verticalMapping: true
            }
        },
        computed: {
            notLoaded() {
                return this.$store.getters.loadingProgress !== 100;
            },
            // mix the getters into computed with object spread operator
            ...mapGetters(['loadingProgress'])
        },
        methods: {
            onSettingChange: function (prop) {
                this[prop] = !this[prop]
                this.$store.commit('updateSettings', {
                    gradientScope: this.gradientScope,
                    nodeView: this.nodeView,
                    verticalMapping: this.verticalMapping
                });

            }
        }
    }
</script>

<style scoped>

</style>
